import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor() {}

  getOldDesignLink(): string {
    return window.location.pathname.indexOf('dashboard') > -1 ?
      `${window.location.origin}/old-design/profile/offer-data` :
      `${window.location.origin}/old-design${window.location.pathname}`;
  }
}
